/* unplugin-vue-components disabled */import { render } from "./html-mapper.vue?vue&type=template&id=48167f67"
import script from "./html-mapper.vue?vue&type=script&lang=js"
export * from "./html-mapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/md-content/html-mapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48167f67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48167f67', __exports__)) {
    api.reload('48167f67', __exports__)
  }
  
  module.hot.accept("./html-mapper.vue?vue&type=template&id=48167f67", () => {
    api.rerender('48167f67', render)
  })

}


export default __exports__